const EditMultiple = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.5 18A2.5 2.5 0 0 0 6 20.5h8a2.5 2.5 0 0 0 2.45-2.003c.055-.27-.174-.497-.45-.497s-.492.23-.582.49A1.5 1.5 0 0 1 14 19.5H6A1.5 1.5 0 0 1 4.5 18v-8a1.5 1.5 0 0 1 1.01-1.418C5.77 8.492 6 8.276 6 8s-.226-.505-.497-.45A2.5 2.5 0 0 0 3.5 10z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M10 16.5A2.5 2.5 0 0 1 7.5 14V6A2.5 2.5 0 0 1 10 3.5h3.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 0 8.5 6v8a1.5 1.5 0 0 0 1.5 1.5h8a1.5 1.5 0 0 0 1.5-1.5v-3.5a.5.5 0 0 1 1 0V14a2.5 2.5 0 0 1-2.5 2.5z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.183 3.891a.5.5 0 0 0-.707 0l-5.55 5.55-.177.884.884-.177 5.55-5.55a.5.5 0 0 0 0-.707m-1.414-.707a1.5 1.5 0 1 1 2.12 2.121l-5.549 5.55a1 1 0 0 1-.51.274l-1.252.25a.75.75 0 0 1-.883-.882l.25-1.252a1 1 0 0 1 .274-.511z"
      clipRule="evenodd"
    />
  </>
)
export default EditMultiple
